import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant/routes";
import { RegisterForm } from "../../components/ui/RegisterForm";
import AuthLink from "../../components/common/AuthLink";
import AuthLayout from "../../components/layouts/AuthLayout";
import logo from "../../assets/llb360.png";

const RegisterPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout>
      <div className="authContainer">
        <Link to={ROUTES.HOME} className="flex justify-center w-full mb-4">
          <img src={logo} alt="LLB360 Logo" className="w-28" loading="lazy"/>
        </Link>
        <h2 className="authSubtitle">User Register</h2>
        <RegisterForm onSuccess={() => navigate(ROUTES.LOGIN)} />
      </div>
      <AuthLink
        text="Already have an account?"
        linkText="Sign In."
        linkTo={ROUTES.LOGIN}
      />
    </AuthLayout>
  );
};

export default RegisterPage;
